<div class="estimate-hours-container">
    <div class="estimate-hours-heading">When do you need your solution estimate back?</div>
    <form [formGroup]="estimateHours">
        <div class="row">
            <div *ngFor="let hour of estimateHoursList" class="col-lg-4 col-sm-4 mb-2">
                <label class="estimate-hour-card" [class.selected]="estimateHours.get('estimateHour')?.value === hour.value">
                    <input type="radio" formControlName="estimateHour" [value]="hour.value" (change)="saveHour(hour)">
                    <span class="hour-label">{{ hour.placeHolder }}</span>
                    <span class="hour-price">${{ productPrice + hour.price | number: '1.2-2' }}</span>
                </label>
            </div>
        </div>
    </form>
</div>
